import { HIDE_PLAYER_ERROR, SHOW_PLAYER_ERROR } from 'containers/Player/actions/errors/constants';

const initialState = {
  error: null,
  showing: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_PLAYER_ERROR:
      return {
        error: action.error,
        showing: true,
      };
    case HIDE_PLAYER_ERROR:
      return { ...initialState };
    default:
      return state;
  }
};
